import { HOME_URI, ANALYTICS_URI } from 'library-@/config/apiConfig';
export const CUSTOM_FILED_NOT_EMPTY = '___NOT_EMPTY___';
export const CUSTOM_FILED_EMPTY = '___EMPTY___';

export const HTTP_METHODS_GET = 'get';
export const HTTP_METHODS_POST = 'post';
export const AN_ADD = 'AN_ADD';
export const ANC_ADD = 'ANC_ADD';
export const ATC = 'ATC';
export const AT = 'AT';
export const IN = 'IN';
export const APN = 'APN';
export const GBC = 'GBC';
export const IPC = 'IPC';
export const UPC = 'UPC';
export const LOC = 'LOC';
export const CPC = 'CPC';
export const ANC = 'ANC';
export const AN = 'AN';
export const ANCS = 'ANCS';
export const ANS = 'ANS';
export const CITED_COUNT = 'CITED_COUNT';
export const CITE_COUNT = 'CITE_COUNT';
export const SIMPLE_FAMILY_COUNT = 'SIMPLE_FAMILY_COUNT';
export const INPADOC_FAMILY_COUNT = 'INPADOC_FAMILY_COUNT';
export const EXTEND_FAMILY_COUNT = 'EXTEND_FAMILY_COUNT';
export const PN = 'PN';
export const LEGAL = 'LEGAL';
export const TITLE = 'TITLE';

export const IE_VERSION = (() => {
    const ua = window.navigator.userAgent;
    const match = ua.match(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i);
    return (match && match.length > 0 && match[1]) || '';
})();

export const COUNTRY_PRIORITY_OPTIONS = [
    'AP',
    'AR',
    'AT',
    'AU',
    'BA',
    'BE',
    'BG',
    'BR',
    'BY',
    'CA',
    'CH',
    'CL',
    'CN',
    'CO',
    'CR',
    'CS',
    'CU',
    'CY',
    'CZ',
    'DD',
    'DE',
    'DK',
    'DO',
    'DZ',
    'EA',
    'EC',
    'EE',
    'EG',
    'EP',
    'ES',
    'FI',
    'FR',
    'GB',
    'GC',
    'GE',
    'GR',
    'GT',
    'HK',
    'HN',
    'HR',
    'HU',
    'ID',
    'IE',
    'IL',
    'IN',
    'IS',
    'IT',
    'JP',
    'KE',
    'KR',
    'KZ',
    'LT',
    'LU',
    'LV',
    'MZ',
    'MC',
    'MD',
    'MN',
    'MT',
    'MW',
    'MX',
    'MY',
    'NI',
    'NL',
    'NO',
    'NZ',
    'OA',
    'PA',
    'PE',
    'PH',
    'PL',
    'PT',
    'RO',
    'RS',
    'RU',
    'SE',
    'SG',
    'SI',
    'SK',
    'SM',
    'SU',
    'SV',
    'TJ',
    'TR',
    'TW',
    'UA',
    'US',
    'UY',
    'VN',
    'WO',
    'YU',
    'ZA',
    'ZM',
    'ZW'
];

export const FE_HOME_URL = HOME_URI;
export const FE_ANALYTICS_URI = ANALYTICS_URI;

// 极验ID
export const CORPTREE_GEETEST_ID = 'd2a59deaf70cff5fce276abd41748fbf';

export const EXPORT_GEETEST_ID = '39ac0e36fc131c330d6283283a92dbce';

export const SF_FACET = 'SF_FACET';

export const PREJECT_QUERY_PREVIEW_COUNT_CACHE = 'previewCountCache';

// localstorage key => 专家检索query排序
export const PREJECT_QUERY_ORDER = 'PREJECT_QUERY_ORDER';

//法律状态显示层级的code
export const SUPPORT_LEVEL_LEGAL_STATUS_CODE = ['11', '30'];
